var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.04865C16 3.60384 12.4179 0 8 0C3.58206 0 0 3.60384 0 8.04865C0 12.0656 2.92507 15.3955 6.75012 16V10.3758H4.71832V8.04865H6.75012V6.27501C6.75012 4.25802 7.94488 3.14314 9.7719 3.14314C10.6471 3.14314 11.5629 3.30046 11.5629 3.30046V5.28124H10.5538C9.56041 5.28124 9.24988 5.9015 9.24988 6.53872V8.04858H11.4684L11.114 10.3757H9.24981V15.9999C13.0749 15.3966 15.9999 12.0667 15.9999 8.04858L16 8.04865Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3dfd215a14c80b935d1f50df632ff7e8.svg";
export { ForwardRef as ReactComponent };